import { VERIFICADNI_ERROR, VERIFICADNI_SUCCESS, VERIFICADNI_LOADING, VERIFICADNI_LOGOUT, RESET_PORTAL_CONTEXT } from "../ActionTypes";

import verificaDniInitialState from "../initialStates/verificaDniInitialState";

const verificaDni = (state, { payload, type }) => {
  switch (type) {
    case VERIFICADNI_LOADING:
      return {
        ...state,
        verificaDni: {
          ...state.verificaDni,
          error: false,
          loading: true,
        },
      };
    case VERIFICADNI_SUCCESS:
      return {
        ...state,
        verificaDni: {
          ...state.verificaDni,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case VERIFICADNI_ERROR:
      return {
        ...state,
        verificaDni: {
          ...state.verificaDni,
          error: payload,
          loading: false,
        },
      };

    case VERIFICADNI_LOGOUT:
      return verificaDniInitialState;
      
    case RESET_PORTAL_CONTEXT:
      return verificaDniInitialState;

    default:
      return state;
  }
};

export default verificaDni;